import React from "react";
import ReactDOM from "react-dom";
import HorizontalGallery from "react-dynamic-carousel";

import ContentLoader, { Facebook } from "react-content-loader";



export const SkRescheduleHistoryCard = (props) => (

  <ContentLoader  {...props}>
      <rect x="500" y="45" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="40" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="50" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="60" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="70" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="125" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="117" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="140" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="150" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="160" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="170" rx="3" ry="3" width="300" height="6" />
  
    </ContentLoader>
  );
export const SkRescheduleDetailsCard = (props) => (

  <ContentLoader  {...props}>
      <rect x="500" y="45" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="40" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="50" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="60" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="70" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="125" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="117" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="140" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="150" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="160" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="170" rx="3" ry="3" width="300" height="6" />
  
    </ContentLoader>
  );

export const SkSingleCancellationCard = () =>(
 

   <ContentLoader viewBox="0 0 450 400">
 
 <rect x="150" y="60" rx="3" ry="3" width="40%" height="10" />
 <rect x="150" y="80" rx="3" ry="3" width="40%" height="10" />
 <rect x="150" y="100" rx="3" ry="3" width="40%" height="10" />
 <rect x="150" y="120" rx="3" ry="3" width="40%" height="10" />

 </ContentLoader>

)

export const SkResReceiptCard = () =>(
  <ContentLoader viewBox="0 0 450 400">
 <rect x="0" y="10" rx="3" ry="3" width="100" height="100" />
 {/* <rect x="150" y="27" rx="4" ry="4" width="50%" height="23" /> */}
 {/* <rect x="150" y="60" rx="3" ry="3" width="40%" height="10" /> */}
 
 
 <rect x="0" y="140" rx="3" ry="3" width="35%" height="10" />
 <rect x="0" y="160" rx="3" ry="3" width="35%" height="10" />
 <rect x="0" y="180" rx="3" ry="3" width="35%" height="10" />
 {/* <rect x="220" y="140" rx="3" ry="3" width="35%" height="10" /> */}
 {/* <rect x="0" y="160" rx="3" ry="3" width="35%" height="10" />
 <rect x="220" y="160" rx="3" ry="3" width="35%" height="10" /> */}
 </ContentLoader>
)

export const SkReschedulingHistoryCard = () =>(
  <ContentLoader  viewBox="0 0 700 300">
    <rect x="0" y="10" rx="3" ry="3" width="180" height="130" />
    <rect x="200" y="27" rx="4" ry="4" width="60%" height="23" />
    <rect x="200" y="60" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="80" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="100" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="120" rx="3" ry="3" width="50%" height="10" />


    <rect x="0" y="160" rx="3" ry="3" width="180" height="130" />
    <rect x="200" y="187" rx="4" ry="4" width="60%" height="23" />
    <rect x="200" y="200" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="220" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="240" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="260" rx="3" ry="3" width="50%" height="10" />

  </ContentLoader>
)
export const SkCancellationHistoryCard = () =>(
  <ContentLoader  viewBox="0 0 700 300">
    <rect x="0" y="10" rx="3" ry="3" width="180" height="130" />
    <rect x="200" y="27" rx="4" ry="4" width="60%" height="23" />
    <rect x="200" y="60" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="80" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="100" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="120" rx="3" ry="3" width="50%" height="10" />


    <rect x="0" y="160" rx="3" ry="3" width="180" height="130" />
    <rect x="200" y="187" rx="4" ry="4" width="60%" height="23" />
    <rect x="200" y="200" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="220" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="240" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="260" rx="3" ry="3" width="50%" height="10" />

  </ContentLoader>
)

export const SkBookingCancellationCard = () =>(
 
  <ContentLoader viewBox="0 0 650 400">
  <rect x="500" y="45" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="40" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="50" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="60" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="70" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="125" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="117" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="140" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="150" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="160" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="170" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="175" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="217" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="240" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="250" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="260" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="270" rx="3" ry="3" width="300" height="6" />
</ContentLoader>
 
)

export const SkReschedulingCard = () =>(
 
  <ContentLoader viewBox="0 0 650 400">
  <rect x="500" y="45" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="40" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="50" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="60" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="70" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="125" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="117" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="140" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="150" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="160" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="170" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="175" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="217" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="240" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="250" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="260" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="270" rx="3" ry="3" width="300" height="6" />
</ContentLoader>
 
)

export const SkBoardingPassCard = () =>(
 
  <ContentLoader viewBox="0 0 650 400">
  <rect x="500" y="45" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="40" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="50" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="60" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="70" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="125" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="117" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="140" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="150" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="160" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="170" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="175" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="217" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="240" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="250" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="260" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="270" rx="3" ry="3" width="300" height="6" />
</ContentLoader>
 
)

export const SkBookingHistoryCard = () =>(
 
  <ContentLoader viewBox="0 0 650 400">
  <rect x="500" y="45" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="40" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="50" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="60" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="70" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="125" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="117" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="140" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="150" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="160" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="170" rx="3" ry="3" width="300" height="6" />
 
  <rect x="500" y="175" rx="5" ry="5" width="100" height="30" />
  <rect x="0" y="217" rx="4" ry="4" width="400" height="13" />
  <rect x="0" y="240" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="250" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="260" rx="3" ry="3" width="300" height="6" />
  <rect x="0" y="270" rx="3" ry="3" width="300" height="6" />
</ContentLoader>
 
)

export const SKInstruction = () => (
  <ContentLoader viewBox="0 0 450 500">
 <rect x="0" y="10" rx="3" ry="3" width="70%" height="10" />
 <rect x="0" y="30" rx="3" ry="3" width="70%" height="10" />
 <rect x="0" y="50" rx="3" ry="3" width="70%" height="10" />
 </ContentLoader>
)

export const SKBulkReceipt = () => (

  <ContentLoader viewBox="0 0 450 500">
 <rect x="120" y="20" rx="4" ry="4" width="40%" height="23" />
 <rect x="0" y="80" rx="3" ry="3" width="30%" height="10" />
 <rect x="280" y="80" rx="3" ry="3" width="30%" height="10" />
 
 <rect x="0" y="105" rx="3" ry="3" width="30%" height="10" />
 <rect x="280" y="105" rx="3" ry="3" width="30%" height="10" />
 <rect x="0" y="125" rx="3" ry="3" width="30%" height="10" />
 <rect x="280" y="125" rx="3" ry="3" width="30%" height="10" />
 </ContentLoader>
)

export const SkReceiptCard = () =>(
  <ContentLoader viewBox="0 0 450 400">
 <rect x="0" y="10" rx="3" ry="3" width="100" height="100" />
 <rect x="150" y="27" rx="4" ry="4" width="50%" height="23" />
 <rect x="150" y="60" rx="3" ry="3" width="40%" height="10" />
 <rect x="150" y="80" rx="3" ry="3" width="40%" height="10" />
 <rect x="0" y="120" rx="3" ry="3" width="35%" height="10" />
 <rect x="220" y="120" rx="3" ry="3" width="35%" height="10" />
 
 <rect x="0" y="140" rx="3" ry="3" width="35%" height="10" />
 <rect x="220" y="140" rx="3" ry="3" width="35%" height="10" />
 <rect x="0" y="160" rx="3" ry="3" width="35%" height="10" />
 <rect x="220" y="160" rx="3" ry="3" width="35%" height="10" />
 </ContentLoader>
)

export const SkSubimgCard = () => (

  <ContentLoader viewBox="0 0 390 90">
    <rect x="0" y="0" rx="5" ry="5" width="65" height="70" />
    <rect x="80" y="0" rx="5" ry="5" width="65" height="70" />
    <rect x="160" y="0" rx="5" ry="5" width="65" height="70" />
    <rect x="240" y="0" rx="5" ry="5" width="65" height="70" />
    <rect x="320" y="0" rx="5" ry="5" width="65" height="70" />

    <rect x="0" y="75" rx="3" ry="3" width="65" height="10" />
    <rect x="80" y="75" rx="3" ry="3" width="65" height="10" />
    <rect x="160" y="75" rx="3" ry="3" width="65" height="10" />
    <rect x="240" y="75" rx="3" ry="3" width="65" height="10" />
    <rect x="320" y="75" rx="3" ry="3" width="65" height="10" />

  </ContentLoader>
  // </HorizontalGallery>
);

export const SkBoatListCard = (props) => (

<ContentLoader  {...props}>
    <rect x="0" y="10" rx="3" ry="3" width="180" height="130" />
    <rect x="200" y="27" rx="4" ry="4" width="60%" height="23" />
    <rect x="200" y="60" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="80" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="100" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="120" rx="3" ry="3" width="50%" height="10" />


    <rect x="0" y="160" rx="3" ry="3" width="180" height="130" />
    <rect x="200" y="187" rx="4" ry="4" width="60%" height="23" />
    <rect x="200" y="200" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="220" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="240" rx="3" ry="3" width="50%" height="10" />
    <rect x="200" y="260" rx="3" ry="3" width="50%" height="10" />

  </ContentLoader>
);

export const SkOtherServiceCard = () => (
  <ContentLoader viewBox="0 0 450 305">
  <rect x="60" y="10" rx="5" ry="5" width="30" height="20" />
  <rect x="205" y="10" rx="5" ry="5" width="30" height="20" />
  <rect x="360" y="10" rx="5" ry="5" width="30" height="20" />

  <rect x="10" y="45" rx="3" ry="3" width="90" height="10" />
  <rect x="160" y="45" rx="3" ry="3" width="90" height="10" />
  <rect x="320" y="45" rx="3" ry="3" width="90" height="10" />

  <rect x="25" y="65" rx="3" ry="3" width="60" height="5" />
  <rect x="180" y="65" rx="3" ry="3" width="60" height="5" />
  <rect x="335" y="65" rx="3" ry="3" width="60" height="5" />

  <rect x="60" y="105" rx="5" ry="5" width="30" height="20" />
  <rect x="205" y="105" rx="5" ry="5" width="30" height="20" />
  <rect x="360" y="105" rx="5" ry="5" width="30" height="20" />

  <rect x="10" y="135" rx="3" ry="3" width="90" height="10" />
  <rect x="160" y="135" rx="3" ry="3" width="90" height="10" />
  <rect x="320" y="135" rx="3" ry="3" width="90" height="10" />

  <rect x="25" y="155" rx="3" ry="3" width="60" height="5" />
  <rect x="180" y="155" rx="3" ry="3" width="60" height="5" />
  <rect x="335" y="155" rx="3" ry="3" width="60" height="5" />

</ContentLoader>
);

